<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchParam" :model="searchParam" label-width="80px">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="科目类型" label-width="80px" prop="pid">
              <el-select v-model="searchParam.pid" placeholder="请选择" clearable>
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="科目名称" label-width="80px" prop="name">
              <el-input v-model="searchParam.name" placeholder="请输入科目名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item>
              <el-button type="primary" @click="getSearchList()">查询</el-button>
              <el-button @click="resetForm('searchParam')">清空已选</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-plus" @click="addFormVisible = true">添加科目</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-table :data="list" border style="width: 100%;margin-top:20px">
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column prop="pname" label="科目类型" width="300"></el-table-column>
          <el-table-column prop="name" label="科目" width="300"></el-table-column>
          <el-table-column prop="number" label="类型编号"></el-table-column>
          <el-table-column prop="remark" label="备注"></el-table-column>
          <el-table-column label="状态" width="100" prop="state">
            <template slot-scope="scope">
              <el-switch
                @change="changeState(scope.row)"
                v-model="scope.row.state==1"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </template>

            <!-- <template slot-scope="scope">{{scope.row.state==1?'启用':'禁用'}}</template> -->
          </el-table-column>
          <el-table-column prop="course" label="操作" width="100">
            <template slot-scope="scopeBtn">
              <el-button type="text" size="small" @click="editBtn(scopeBtn.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>

      <el-pagination
        background
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px;text-align: right;"
        :total="returnVal.total"
        :page-size="returnVal.size"
        :current-page="returnVal.current"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <!------------------------------------------ 添加 ------------------------------------------->
    <el-dialog title="添加科目" :visible.sync="addFormVisible" width="500px">
      <el-form ref="addForm" :model="addForm" label-width="80px" :rules="addRules">
        <el-form-item label="科目类型" label-width="80px" prop="pid">
          <el-select v-model="addForm.pid" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="addForm.number"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort" v-model="addForm.sort">
          <el-input v-model.number="addForm.sort"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="addForm.remark" type="textarea" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch v-model="addForm.state" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button @click="resetForm('addForm')">重 置</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------ 编辑 ------------------------------------------->
    <el-dialog title="编辑科目" :visible.sync="editFormVisible" width="500px">
      <el-form ref="editForm" :model="editForm" label-width="80px" :rules="addRules">
        <el-form-item label="科目类型" label-width="80px" prop="pid">
          <el-select v-model="editForm.pid" placeholder="请选择">
            <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="科目名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="类型编号" prop="number">
          <el-input v-model.number="editForm.number" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="显示排序" prop="sort" v-model="editForm.sort">
          <el-input v-model.number="editForm.sort" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="备注说明" prop="remark">
          <el-input v-model="editForm.remark" type="textarea" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="state">
          <el-switch
            :disabled="true"
            v-model="editForm.state==1"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [], //科目
      typeList: [], //科目类型
      returnVal: {},
      editForm: {},
      editParam: {},
      label: "1",
      editFormVisible: false,
      addFormVisible: false,
      typeParam: {
        name: "",
        level: 0,
        pageSize: 10,
        pageNumber: 1
      },
      searchParam: {
        name: "",
        level: 1,
        pid: "",
        pageSize: 10,
        pageNumber: 1
      },
      param: {
        name: "",
        level: 1,
        pid: "",
        pageSize: 10,
        pageNumber: 1
      },
      addForm: {
        level: 1,
        pid: "",
        name: "",
        number: "",
        sort: "",
        remark: "",
        state: true
      },
      addRules: {
        pid: [{ required: true, message: "请输入科目类型", trigger: "change" }],
        name: [{ required: true, message: "请输入科目名称", trigger: "blur" }],
        number: [
          { required: true, message: "请输入类型编号", trigger: "blur" },
          { type: "number", message: "类型编号必须为数字" }
        ],
        sort: [
          { required: true, message: "请输入显示排序", trigger: "blur" },
          { type: "number", message: "显示排序必须为数字" }
        ]
      }
    };
  },
  methods: {
    currentChange(pageNumber) {
      this.param.pageNumber = pageNumber;
      this.getList();
    },
    changeState(e) {
      console.log(e);
      if (e.state == 1) {
        this.$confirm(
          "禁用此科目类型会把下属的科目和课程全部禁用,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.api.subjectCourse
              .offSubjectCourse({
                id: e.id
              })
              .then(result => {
                if (result.code == 200) {
                  this.$message({
                    message: result.message,
                    type: "success"
                  });
                  this.getList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        this.$confirm(
          "开启此科目类型会把下属的科目和课程全部开启,是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.api.subjectCourse
              .onSubjectCourse({
                id: e.id
              })
              .then(result => {
                if (result.code == 200) {
                  this.$message({
                    message: result.message,
                    type: "success"
                  });
                  this.getList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      }
    },
    getTypeLit() {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0
        })
        .then(result => {
          this.typeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getSearchList() {
      this.param = JSON.parse(JSON.stringify(this.searchParam));
      this.api.subjectCourse
        .getPageList(this.searchParam)
        .then(result => {
          this.list = result.data.records;
          this.returnVal = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getList() {
      this.api.subjectCourse
        .getPageList(this.param)
        .then(result => {
          this.list = result.data.records;
          this.returnVal = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    editBtn(list) {
      this.editFormVisible = true;
      this.editForm = JSON.parse(JSON.stringify(list));
    },
    submitEdit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.subjectCourse
            .updateSubjectCourse(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success"
                });
                this.editFormVisible = false;
                this.getList();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    submitAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          console.log(this.addForm);
          var param = this.addForm;
          if (this.addForm.state) {
            param.state = 1;
          } else {
            param.state = -1;
          }
          this.api.subjectCourse
            .addSubjectCourse(param)
            .then(result => {
              if (result.success) {
                this.$message({
                  message: "恭喜你，操作成功",
                  type: "success"
                });
                this.addFormVisible = false;
                this.getList();
              } else {
                this.$message.error("操作失败，请重试");
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    //重置表格
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },

  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
      } else {
      }
    }
  },
  mounted() {
    this.getTypeLit(); //科目类型
    this.getList(); //科目
  }
};
</script>


// WEBPACK FOOTER //
// src/components/subject/subjectManage.vue